"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewProjectDialogOrigin = exports.TrackingEventActions = void 0;
/**
 * @deprecated This object was created to help prevent typos / facilitate Amplitude
 * browsing.
 * QUESTION: what to replace it with?
 *
 * TODO: refactor to separate files for each. Using typing like that of `trackPartUpdateEvent`
 * on AnalyticsStorage.
 **/
exports.TrackingEventActions = {
    createDocument: {
        blank: "blank",
        clone: "clone",
        fork: "fork",
    },
    copilot: {
        import: {
            importSingle: "import_single",
            importAll: "import_all",
            closeDialog: "close_datasheet_import_dialog",
            openDialog: "open_datasheet_import_dialog",
            jobDataReceived: "job_data_received",
            uploadPdfClicked: "upload_pdf_clicked",
            pdfUploaded: "pdf_uploaded",
            cancelImportJobClicked: "cancel_import_job_clicked",
            importComponentInitialTemplateMatchComplete: "import_component_initial_template_match_complete",
        },
    },
    changeHistory: {
        revertOrForward: "revertOrForward",
        restore: "restore",
        cancel: "cancel",
    },
};
/**
 * All the "surface" values for newProjectDialog->open, places from which the
 * new project dialog can be opened.
 */
exports.NewProjectDialogOrigin = {
    hotkey: "hotkey",
    menu: "menu",
    profile: "profile",
};
//# sourceMappingURL=TrackingEvents.js.map